import { z } from 'zod'

import { IntegrationSchema } from 'shared/api/common/schemas/integration'

const HubspotFieldSchema = z.object({
  name: z.string(),
  label: z.string(),
  type: z.string(),
  fieldType: z.string(),
  required: z.boolean(),
  options: z.array(z.unknown()),
})

const HubspotFormSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  fields: z.array(HubspotFieldSchema),
})

export const HubspotSchemas = {
  setAccountLinkField: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ field_id: z.string().nullable(), field_name: z.string().nullable() }),
    response: z.object({ hubspot: IntegrationSchema }),
  },
  clearAccountLinkField: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ hubspot: IntegrationSchema }),
  },
  fetchForms: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ forms: z.array(HubspotFormSchema).or(z.array(z.void()).length(0)) }),
  },
  getFormById: {
    path: z.undefined(),
    query: z.object({ form_id: z.string() }),
    request: z.undefined(),
    response: z.object({ form: HubspotFormSchema }),
  },
  getContactFields: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      fields: z.array(
        z.object({
          name: z.string(),
          label: z.string(),
          type: z.string(),
          fieldType: z.string(),
          options: z
            .array(
              z.object({
                label: z.string(),
                value: z.string(),
                description: z.string().optional(),
                displayOrder: z.number(),
                hidden: z.boolean(),
              }),
            )
            .or(z.array(z.void()).length(0)),
        }),
      ),
    }),
  },
  getFormFields: {
    path: z.undefined(),
    query: z.object({ form_id: z.string() }),
    request: z.undefined(),
    response: z.object({ fields: z.array(HubspotFieldSchema) }),
  },
}
